import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function WireLongformGuide({ copy }) {
  const guide = copy.longform;

  return (
    <section className="mt-10 rounded-[2rem] border border-border bg-card p-6 shadow-xl md:p-8">
      <p className="text-sm font-black uppercase tracking-[0.22em] text-primary">{guide.eyebrow}</p>
      <h2 className="mt-3 font-heading text-3xl font-black md:text-5xl">{guide.title}</h2>
      <p className="mt-4 max-w-3xl text-base leading-8 text-muted-foreground">{guide.intro}</p>
      <div className="mt-8 grid gap-5 md:grid-cols-2">
        {guide.sections.map((section) => (
          <article key={section.title} className="rounded-3xl border border-border bg-background/70 p-5">
            <h3 className="text-xl font-black text-foreground">{section.title}</h3>
            <p className="mt-3 text-sm leading-7 text-muted-foreground">{section.body}</p>
          </article>
        ))}
      </div>
      <div className="mt-8 rounded-3xl border border-primary/20 bg-primary/5 p-5">
        <h3 className="text-2xl font-black text-foreground">{guide.checklistTitle}</h3>
        <div className="mt-5 grid gap-3 md:grid-cols-2">
          {guide.checklist.map((item) => (
            <div key={item} className="flex gap-3 rounded-2xl bg-card p-4 text-sm font-semibold text-foreground">
              <CheckCircle2 className="h-5 w-5 shrink-0 text-primary" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}